@if (availableLanguages().length > 1) {
    <ng-select
        [items]="availableLanguages()"
        [ngModel]="selectedLanguage()?.code"
        [clearable]="false"
        [searchable]="false"
        (ngModelChange)="selectLanguage($event)"
        bindValue="code"
        class="form-control form-control-brand p-0"
        [ngClass]="stylingClass"
    >
        <ng-template ng-option-tmp let-language="item">
            <div class="d-flex align-items-center justify-content-center">
                <img [src]="language.flag" [alt]="language.code" width="24" height="18" class="me-2 rounded-1" />
            </div>
        </ng-template>

        <ng-template ng-label-tmp let-item="item">
            @if (selectedLanguage()) {
                <img [src]="item?.flag" [alt]="item?.code" width="24" height="18" class="rounded-1 d-block" />
            } @else {
                <i class="las la-globe"></i>
            }
        </ng-template>
    </ng-select>
}
